// extracted by mini-css-extract-plugin
export default {"container":"Signup_container__BjwMi","innerBox":"Signup_innerBox__IZA7a","footer":"Signup_footer__IO+K1","error":"Signup_error__-j7nO"};